import { ThunkDispatch } from 'store/store';
import { v4 as uuid } from 'uuid';
import State from 'store/State';
import Services from 'store/Services';
import {
    hideNotificationAction,
    NotificationAction,
    showNotificationAction,
} from './actions';
import { NotificationType } from '@instinet-analytics/semantic-ui-components';
import { LogLevel } from '@instinet-analytics/core-lib';

const HIDE_NOTIFICATION_TIMEOUT = 10000;

export const showNotificationAsync =
    (message: string, type: NotificationType, title?: string) =>
    async (
        dispatch: ThunkDispatch<NotificationAction>,
        _getState: () => State,
        { loggingService }: Services
    ) => {
        const id = uuid();

        dispatch(showNotificationAction(id, message, type, title));

        loggingService.logMessage(
            type === NotificationType.Warning
                ? LogLevel.Warning
                : LogLevel.Debug,
            'Notification',
            message,
            { type, title, message }
        );

        setTimeout(() => {
            dispatch(hideNotificationAction(id));
        }, HIDE_NOTIFICATION_TIMEOUT);
    };

export const showInfoAsync = (message: string, title?: string) =>
    showNotificationAsync(message, NotificationType.Info, title);

export const showWarningAsync = (message: string, title?: string) =>
    showNotificationAsync(message, NotificationType.Warning, title);
